<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>培训档案</b>
        <div class="tips">
          <span
            >学习课程：<i class="uc-blue">{{
              $store.getters.statistics.study_course
            }}</i></span
          >
          <span
            >已完成课程：<i class="uc-blue">{{
              $store.getters.statistics.finish_course
            }}</i></span
          >
          <span
            >学习中课程：<i class="uc-blue">{{
              $store.getters.statistics.un_finish_course
            }}</i></span
          >
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a href="javascript:;" @click="loadData" class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="filter">
        <el-dropdown @command="handleCommand" class="uc-pl30">
          <span class="el-dropdown-link">
            {{ custom }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropDownData"
              :key="index"
              :command="{ value: item.val, label: item.label }"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div class="link">共 {{ list.total_count }} 条</div>
      </div>
      <div class="table">
        <table>
          <tr>
            <th style="width:10%;">序</th>
            <th style="width:38%;" class="left">课程名称</th>
            <th style="width:14%;">课时</th>
            <th style="width:14%;">累计学习时长</th>
            <th style="width:14%;">学习进度</th>
            <th style="width:10%;">状态</th>
          </tr>
          <tr v-show="list.total_count == 0">
            <td colspan="10">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">
              <router-link
                :to="{
                  name: 'CourseDetails',
                  params: { id: item.course_id },
                }"
              >
                {{ item.name }}
              </router-link>
            </td>
            <td>{{ item.period }}分钟</td>
            <td>{{ (item.learn_duration / 60).toFixed(1) }}分钟</td>
            <td class="left" style="padding-left:1%;">
              <el-progress :percentage="item.browse_percent"></el-progress>
            </td>
            <td :class="item.browse_percent === 100 ? 'uc-green' : 'uc-orange'">
              <b>{{ item.browse_percent == 100 ? '已完成' : '学习中' }}</b>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PersonalStudy',
  data() {
    return {
      query: {
        status: -1,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      model: {},
      list: [],

      dropDownData: [
        { label: '全部', val: -1 },
        { label: '学习中', val: 0 },
        { label: '已完成', val: 1 },
      ],
      custom: '全部',
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLearningRecords();
    },
    handleCommand(command) {
      this.custom = command.label;
      this.query.status = command.value;
      this.query.pageIndex = 1;
      this.loadData();
    },
    async getLearningRecords() {
      const response = await this.$api.user.getLearningRecords(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
